import { combineReducers } from 'redux';

import dividendsReducer from './Dividends/slice';
import interestReducer from './Interest/slice';
import pensionReducer from './Pension/slice';
import wagesReducer from './Wages/slice';
import generalReducer from './General/slice';

export default combineReducers({
  general: generalReducer,
  dividends: dividendsReducer,
  interest: interestReducer,
  pension: pensionReducer,
  wages: wagesReducer,
});
